var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRteH1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "10px",
    viewBox: "0 0 17 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rich-text-updates",
    transform: "translate(-400.000000, -116.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-h1",
    transform: "translate(401.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.65517241,5 L8.27586207,5",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.11111111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.555555556 L3.31034483,0.555555556",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.11111111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9.44444444 L3.31034483,9.44444444",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.11111111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62068966,0.555555556 L9.93103448,0.555555556",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.11111111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62068966,9.44444444 L9.93103448,9.44444444",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.11111111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65517241,1.11111111 L1.65517241,8.88888889",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 2.22222222,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27586207,1.11111111 L8.27586207,8.88888889",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 2.22222222,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero",
    points: "14.0353103 4.00388889 13.9337931 4.00388889 12.0711724 5.27055556 12.0711724 3.56722222 14.0353103 2.22 16 2.22 16 9.99777778 14.0353103 9.99777778"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRteH1);
export default __webpack_public_path__ + "static/media/icon-rte-h1.fc337890bb73a417729d97ba03e87428.svg";
export { ForwardRef as ReactComponent };